<template>
  <div class="py-5">

    <b-field>
      <b-upload v-model="content.media" multiple drag-drop expanded>
        <section class="section">
          <div class="content has-text-centered">
            <p>Drop your files here or click to upload</p>
          </div>
        </section>
      </b-upload>
    </b-field>

    <div class="columns">
      <media-preview
        v-for="(media, index) in content.media"
        :key="index"
        :media="media"
        @remove="media.markForDelete()">
      </media-preview>
    </div>

    <b-field :label="`Body ${ index + 1 }`">
      <b-input v-model="content.attributes.body" type="textarea"></b-input>
    </b-field>

    <b-field label="Location">
      <b-input v-model="content.attributes.location"></b-input>
    </b-field>

    <div class="buttons">
      <b-button @click="$emit('add', index)" size="is-small">+ Add Content</b-button>
      <b-button @click="content.markForDelete()" size="is-small">- Remove Content</b-button>
    </div>

  </div>
</template>

<script>
import MediaPreview from './media-preview'
export default {
  components: {
    MediaPreview
  },
  props: {
    index: Number,
    content: Object
  }
}
</script>
